import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { UserFull } from '../../models/user-master/user-lite';
import { ApiResponse } from '@card-software/nexus-utilities';

@Injectable({
  providedIn: 'root',
})
export class UserProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/user`;

  getAllUsers(): Observable<ApiResponse<UserFull[]>> {
    return this.httpClient.get<ApiResponse<UserFull[]>>(`${this.baseUrl}/all`);
  }

  getUserByUsername(username: string): Observable<ApiResponse<UserFull>> {
    return this.httpClient.get<ApiResponse<UserFull>>(`${this.baseUrl}/username/${encodeURIComponent(username)}`);
  }
}
